module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPkFydGJvYXJkIDEgY29weSAxMTwvdGl0bGU+PHBhdGggZD0iTTE4LjUsMTlhLjQ3LjQ3LDAsMCwxLS4zNS0uMTVsLTEzLTEzYS40OS40OSwwLDAsMSwuNy0uN2wxMywxM2EuNDguNDgsMCwwLDEsMCwuN0EuNDcuNDcsMCwwLDEsMTguNSwxOVoiLz48cGF0aCBkPSJNNS41LDE5YS40Ny40NywwLDAsMS0uMzUtLjE1LjQ4LjQ4LDAsMCwxLDAtLjdsMTMtMTNhLjQ5LjQ5LDAsMSwxLC43LjdsLTEzLDEzQS40Ny40NywwLDAsMSw1LjUsMTlaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/img/action-close.svg
// module id = 118
// module chunks = 1